
export class UnrollerManager {
  private selector: string = "data-kb-unroller";

  constructor() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.onContentLoaded();
      }, false);
    } else {
      this.onContentLoaded();
    }
  }

  private onContentLoaded(): void {
    const elements = document.querySelectorAll<HTMLElement>(`[${this.selector}]`);

    for (let i = 0; i < elements.length; i++) {
      const el = elements[i];

      const targetSelector = el.dataset.kbUnrollerTarget;
      const itemsSelector = el.dataset.kbUnrollerItems;
      const linkSelector = el.dataset.kbUnrollerLink;

      if (!targetSelector || !itemsSelector || !linkSelector) {
          return;
      }

      const target = document.querySelector(targetSelector) as HTMLElement;

      if (target === null) {
        return;
      }

      const items = target.querySelectorAll<HTMLElement>(`${itemsSelector}.is-hidden`);

      const link = target.querySelector(linkSelector) as HTMLElement;

      el.addEventListener('click', () => {
        for (let i = 0; i < items.length; i++) {
          const item = items[i] as HTMLElement;

          item.classList.remove('is-hidden');
        }

        link.classList.add('is-hidden');
      })
    }
  }
}
